export default __webpack_public_path__ + "static/media/vip-8.a50b2c8e.svg";